import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

import downArrow from 'assets/img/common/ic_arrow_down_black.svg';

interface Props {
  selected?: boolean;
}

export const Select = styled.select<Props>`
  ${theme('fontStyle.body2')}
  ${(props) =>
    props.selected
      ? css`
          color: ${palette('gray_opacity_800')};
        `
      : css`
          color: ${palette('gray_opacity_400')};
        `}
  border: 1px solid ${palette('gray_opacity_200')};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  position: relative;
  border-image: initial;
  background: url('${downArrow}') no-repeat 95% 50%;
  background-color: ${palette('gray_opacity_50')};
  -webkit-appearance: none;
  &::-ms-expand {
    display: none;
  }
`;
